import { render, staticRenderFns } from "./InternalArticlesReceived.vue?vue&type=template&id=21421baa&scoped=true"
import script from "./InternalArticlesReceived.vue?vue&type=script&lang=js"
export * from "./InternalArticlesReceived.vue?vue&type=script&lang=js"
import style0 from "./InternalArticlesReceived.vue?vue&type=style&index=0&id=21421baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21421baa",
  null
  
)

export default component.exports